module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/68/assets/images/24eb181bb4905aae3e10aaf4683f529a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_maximise.svg
// module id = cLZP
// module chunks = 0